// Libs
import axios, { AxiosResponse } from 'axios';
// App
import { CATALOG_SHOPS_URL } from '../shop.constants';
import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';
import { ContactParam } from '../../../contact-us';
import { AxiosHookResponse } from '../../../utils/axios-request.hooks.interfaces';
import { useAxiosPostRequest } from '../../../utils/axios-request.hooks';

/**
 * Contact us api hook
 */
export const useContactShop = (shopId: number): AxiosHookResponse<ContactParam, void> => {
  const url = `${API_COMMON_BASE_URL}/${CATALOG_SHOPS_URL}/${shopId}/contact`;

  return useAxiosPostRequest(url);
};

/**
 * Contact shop api
 */
export const contactShop = (shopId: number, contactParam: ContactParam): Promise<AxiosResponse<void>> => {
  const url = `${API_COMMON_BASE_URL}/${CATALOG_SHOPS_URL}/${shopId}/contact`;

  return axios.post(url, contactParam);
};
